import { ReactNode } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Heading, tokens } from '@treams/treams-ui';

interface IProps {
	title: string;
	children: ReactNode;
}

const Element = styled.ol`
	counter-reset: OrderedList-counter;
	display: block;
`;

export default function OrderedList({ title, children }: IProps) {
	return (
		<>
			<Heading>{title}</Heading>
			<Box>
				<Element>{children}</Element>
			</Box>
		</>
	);
}

export const OrderedListItem = styled.li`
	color: ${tokens.text.secondary};
	line-height: 1.8;
	counter-increment: OrderedList-counter;
	list-style: none;

	&:before {
		content: counter(OrderedList-counter) '.';
		font-size: 18px;
		margin-right: 10px;
		color: ${tokens.text.primary};
	}
`;
